/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const getAll = (st: SpanTag): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/documents`;
  return fetchAPI(stleaf(st, 'iu5eph'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};
